import { InstallAgentPanelController } from '../controller/InstallAgentPanelController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class InstallAgentPanelWebComponent extends BaseWebComponentElement {
  public controller!: InstallAgentPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InstallAgentPanelController,
    });
  }

  public toggleVisibilityRemoveCompetitorInfo(isVisible: boolean): void {
    this.controller.view.toggleVisibilityRemoveCompetitorInfo(isVisible);
  }

  public get value() {
    return this.controller.view.formGroup.value;
  }
}
